// extracted by mini-css-extract-plugin
export default {"productGrid":"Aaa-z","centerLink":"Baa-z","productSection":"Caa-z","item":"Daa-z","ctaButton":"Eaa-z"};